import { useNavigate, useLocation } from "react-router-dom";
import { Home, Award, Newspaper, LifeBuoy, type LucideIcon } from "lucide-react";
import { useT } from "@/i18n";
import type { TranslationKey } from "@/i18n";
import { hapticTap } from "@/tg/init";

interface Tab {
  path: string;
  icon: LucideIcon;
  labelKey: TranslationKey;
}

const TABS: Tab[] = [
  { path: "/home",    icon: Home,      labelKey: "home"    },
  { path: "/levels",  icon: Award,     labelKey: "levels"  },
  { path: "/news",    icon: Newspaper, labelKey: "news"    },
  { path: "/support", icon: LifeBuoy,  labelKey: "support_tab" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const t = useT();

  function isActive(path: string) {
    return pathname === path || pathname.startsWith(path + "/");
  }

  return (
    <nav
      aria-label="Main navigation"
      style={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "calc(100% - 24px)",
        maxWidth: "calc(480px - 24px)",
        marginBottom: "calc(20px + env(safe-area-inset-bottom, 0px))",
        display: "flex",
        background: "#ffffff",
        borderRadius: 28,
        boxShadow: "0 4px 24px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.06)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        zIndex: 100,
        overflow: "hidden",
      }}
    >
      {TABS.map(({ path, icon: Icon, labelKey }) => {
        const active = isActive(path);
        const color = active ? "var(--brand-blue)" : "var(--muted)";

        return (
          <button
            key={path}
            aria-current={active ? "page" : undefined}
            onClick={() => {
              hapticTap();
              navigate(path);
            }}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
              minHeight: 56,
              paddingBlock: 10,
              background: "none",
              border: "none",
              cursor: "pointer",
              WebkitTapHighlightColor: "transparent",
            }}
          >
            <Icon size={22} color={color} strokeWidth={1.75} />
            <span
              style={{
                fontSize: 10,
                fontWeight: active ? 600 : 400,
                lineHeight: 1,
                color,
              }}
            >
              {t(labelKey)}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
